import styled from 'styled-components';

import { DialogMemo } from 'components/dialog';
import { Picture } from 'components/picture';

export const LoadingAnimationWrapper = styled.div`
  max-width: 170px;
  margin: 0 auto;
  margin-block-end: -1.8rem;
  padding-block-start: 1rem;
  padding-block-end: 0;
  padding-inline: 1rem;
`;

export const SuccessAnimationWrapper = styled.div`
  z-index: ${Styles.zIndex.max - 100};
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
`;

export const ImageContainer = styled(Picture)`
  max-width: 130px;
  margin-block-start: 1.5rem;
  margin-block-end: -1rem;
  margin-inline: auto;
`;

export const ParagraphOptOut = styled.p`
  text-align: center;
  font-size: 1rem;
  a {
    color: ${Styles.color.primary};
  }
`;

export const OptInDialog = styled(DialogMemo)`
  max-height: 100vh;
  overflow-y: scroll;
`;

export const ActionWrapper = styled.div`
  margin: 1rem;
  min-width: auto;
  width: 100%;
`;
